import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import DatePicker from "src/components/common/calendar/DatePicker";
import { gridCalendarHeight, gridCalendarLayoutHeight, gridCalendarWidth, searchDateSingleFormString, searchFormString } from "src/components/common/common";
import { formatDate } from "src/utils/string/stringUtil";

interface Props {
	rowIndex: number;
	targetField: string;
	visible: boolean;									setVisible: (visible: boolean) => void;
    value?: Date;
	onClear: () => void;
    onChange: (date: Date | undefined, rowIndex: number, targetField: string) => void;
	onClickLoad: (rowIndex: number, targetField: string) => void;
	pickerPosition: { top: number; left: number };		setPickerPosition: (pickerPosition: { top: number; left: number }) => void;
	yearMonthVisible?: boolean;
	timeEditable?: boolean;
	/** 확인(버튼·Enter·날짜 더블클릭) 직후, 닫기 처리 다음 틱에서 호출 (그리드 포커스 복귀 등) */
	onAfterConfirm?: (rowIndex: number, targetField: string) => void;
}

export const GridCalendar = ( props: Props ) => {

    const { 
		rowIndex,
		targetField,
		visible, setVisible,
		value, 
		onClear,
		onChange,
		onClickLoad,
		pickerPosition, setPickerPosition,
		yearMonthVisible = false,
		timeEditable = false,
		onAfterConfirm,
	} = props;

	const handleClear = () => {
		onClear();
		setVisible(false);
	}

	useEffect(() => {
		if(visible) {
			onClickLoad(rowIndex, targetField);
		}
	}, [visible]);

    return (
		<>
			{visible &&
				ReactDOM.createPortal(
				<>
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: gridCalendarWidth,
						height: gridCalendarLayoutHeight,
						zIndex: 10000,
						// backgroundColor: 'rgba(0,0,0,0.1)', // 필요시 반투명 배경 추가
					}}
					onClick={ () => {
						if(visible) setVisible(false);
					}}
					/>
					<div style={{
								position: 'absolute',
								top: `${pickerPosition.top}px`,
								left: `${pickerPosition.left}px`,
								zIndex: 10001, // DateRangePicker z-index
							}}
							onClick={(e) => e.stopPropagation()}
						>
						<DatePicker
							value={value}
							onChange={(date: Date | undefined) => {
								if(date) {
									onChange(date, rowIndex, targetField);
								}
							}}
							onReset={() => {
								const today = new Date();
								onChange(new Date(today.getFullYear(), today.getMonth(), today.getDate()), rowIndex, targetField);
								setVisible(false);
							}}
							//완료, 더블클릭 시 일어나는 동작
							onConfirm={(date: Date | undefined) => {
								if(date) {
									onChange(date, rowIndex, targetField);
									setVisible(false);
									if (onAfterConfirm) {
										window.setTimeout(() => onAfterConfirm(rowIndex, targetField), 0);
									}
								}
							}}
							onClear={handleClear}
							yearMonthVisible={yearMonthVisible}
							timeEditable={timeEditable}
						/>
					</div>
				</>
				, document.body)
			}
		</>
	)
}